import React, { useState, useEffect, memo } from 'react';
import { Carousel } from 'react-responsive-carousel';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import head from 'lodash/head';
import tail from 'lodash/tail';
import { listingPropTypes } from '../../utils/commonPropTypes';
import CarouselThumbs from '../CarouselThumbs';
import Spinner from '../Spinner';
import CarouselItem from '../CarouselItem';
import {
  getTitle,
  getMediaImages,
  getMediaVideos,
  get360Photos
} from '../../utils/listingHelper';
import { carouselButtonClick } from '../../store/actions';
import {
  changeCarouselImage,
  openCarouselModal
} from '../../store/actions/dataLayer';
import DefaultImage from '../DefaultImage';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import get from 'lodash/get';

import './styles.css';

const CarouselDisplayer = (props) => {
  const {
    selectedItem,
    carouselButtonClick,
    changeCarouselImage,
    device,
    isModal,
    showModal,
    isLoading,
    listing,
    showThumbs
  } = props;
  const [index, setIndex] = useState(selectedItem);

  useEffect(() => {
    setIndex(selectedItem);
  }, [selectedItem]);

  const populateMediaArray = (listing) => {
    let images = getMediaImages(listing);
    let videos = getMediaVideos(listing);
    let images360 = get360Photos(listing);
    if (images.length > 0 || videos.length > 0 || images360.length > 0) {
      if (images.length > 0) {
        return [head(images), ...videos, ...images360, ...tail(images)];
      }
      return [...videos, ...images360];
    }
    return [];
  };

  const handleThumbClick = (event, index) => {
    setIndex(index);
    carouselButtonClick();
  };

  const handleOnChangeCarouselItem = (localIndex) => {
    if (localIndex !== index) {
      setIndex(localIndex);
      changeCarouselImage();
    }
    carouselButtonClick();
  };

  const renderNoImage = () => {
    return (
      <div className="carousel-item" key={0}>
        <div className="item-wrapper">
          <DefaultImage />
        </div>
      </div>
    );
  };

  const renderCarousel = (listing) => {
    let mediaItems = populateMediaArray(listing);
    let title = getTitle(listing);
    let mediaItemToShow = index;
    return (
      <>
        <div className="carousel-button-tray-right-top">
          {index + 1}
          <span>/</span>
          {mediaItems.length}
        </div>
        {mediaItems.length !== 0 ? (
          <Carousel
            className={classnames({
              'carousel-slider-modal': isModal
            })}
            useKeyboardArrows={true}
            showIndicators={false}
            showThumbs={false}
            infiniteLoop={true}
            selectedItem={index}
            onChange={handleOnChangeCarouselItem}
          >
            {mediaItems.map((item, key) => {
              return get(item, 'mediaType') === '360Image' ? (
                <div
                  className={classnames('carousel-item', {
                    'zoom-in': !isModal
                  })}
                  key={key}
                  onClick={() => {
                    if (!isModal) {
                      showModal(key);
                    }
                  }}
                  onTouchStart={(event) => event.stopPropagation()}
                  onTouchEnd={(event) => event.stopPropagation()}
                >
                  <div
                    className={classnames('carousel-div-over', {
                      'hide': isModal
                    })}
                  />
                  <CarouselItem
                    current={key === mediaItemToShow}
                    media={item}
                    title={title}
                    show={mediaItemToShow === key}
                  />
                </div>
              ) : (
                <div
                  className={classnames('carousel-item', {
                    'zoom-in': !isModal
                  })}
                  key={key}
                  onClick={() => {
                    if (!isModal) {
                      showModal(key);
                    }
                  }}
                >
                  <div
                    className={classnames('carousel-div-over', {
                      'hide': isModal
                    })}
                  />
                  <CarouselItem
                    current={key === mediaItemToShow}
                    media={item}
                    title={title}
                    show={mediaItemToShow === key}
                  />
                </div>
              );
            })}
          </Carousel>
        ) : (
          renderNoImage()
        )}
        {showThumbs && (
          <CarouselThumbs
            device={device}
            selectedItem={index}
            handleThumbClick={handleThumbClick}
            carouselButtonClick={carouselButtonClick}
            mediaItems={mediaItems}
          />
        )}
      </>
    );
  };

  const renderLoading = () => {
    return <Spinner />;
  };

  return (
    <>
      {isModal ? (
        <>
          {isLoading || !listing.id ? renderLoading() : renderCarousel(listing)}{' '}
        </>
      ) : (
        <div className="carousel-container">
          {isLoading || !listing.id ? renderLoading() : renderCarousel(listing)}
        </div>
      )}
    </>
  );
};

CarouselDisplayer.defaultProps = {
  selectedItem: 0
};

CarouselDisplayer.propTypes = {
  /** Defines if the component data is loading */
  isLoading: PropTypes.bool,
  /** The listing of data */
  listing: listingPropTypes,
  /** Is this carousel in the modal */
  isModal: PropTypes.bool,
  /** The kind of device: mobile, tablet, desktop */
  device: PropTypes.string,
  /** show thumbnails */
  showThumbs: PropTypes.bool,
  /** the selected item in the carousel */
  selectedItem: PropTypes.number,
  /** function that will be called on change carousel item */
  changeCarouselImage: PropTypes.func,
  /** funcion that will be called on click carousel button */
  carouselButtonClick: PropTypes.func,
  /** showModal on click carousel Item */
  showModal: PropTypes.func
};

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      changeCarouselImage,
      carouselButtonClick,
      openCarouselModal
    },
    dispatch
  )
)(memo(CarouselDisplayer));
